import * as React from 'react'
import { SVGProps } from 'react'

const SvgWrappedBitcoinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M0 0h24v24H0z' />
    <circle cx={12} cy={12} r={12} fill='#fff' />
    <path
      d='m19.463 5.015-.663.663a9.373 9.373 0 0 1 0 12.66l.663.662a10.32 10.32 0 0 0 0-14v.015ZM5.678 5.2a9.373 9.373 0 0 1 12.66 0L19 4.537a10.32 10.32 0 0 0-14 0l.678.663ZM5.2 18.315a9.374 9.374 0 0 1 0-12.652L4.537 5a10.32 10.32 0 0 0 0 14l.663-.685ZM18.322 18.8a9.374 9.374 0 0 1-12.66 0L5 19.463a10.32 10.32 0 0 0 14 0l-.678-.663Z'
      fill='#5A5564'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.122 9.875c-.13-1.377-1.305-1.838-2.79-1.98V6h-1.147v1.86h-.918V6h-1.139v1.909H7.8v1.243s.848-.016.835 0a.595.595 0 0 1 .652.51v5.225a.408.408 0 0 1-.435.385c.015.014-.835 0-.835 0L7.8 16.66h2.307v1.94h1.147v-1.911h.918v1.902h1.15v-1.918c1.939-.118 3.291-.602 3.46-2.439.138-1.478-.55-2.137-1.647-2.404.667-.332 1.08-.947.987-1.955Zm-1.609 4.13c0 1.325-2.06 1.295-2.999 1.28a15.192 15.192 0 0 0-.223-.002v-2.56c.08 0 .177-.002.287-.004.966-.022 2.935-.066 2.935 1.287ZM11.49 11.56c.787.014 2.491.045 2.491-1.161 0-1.237-1.65-1.194-2.453-1.173-.09.003-.168.005-.233.005v2.327c.055 0 .121 0 .195.002Z'
      fill='#F09242'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 12c0 6.626 5.371 11.999 11.998 12A12 12 0 0 0 24 11.998C23.999 5.37 18.626 0 12 0 5.371 0 0 5.372 0 12Zm.949-.002C.946 5.893 5.893.94 11.998.936a11.058 11.058 0 0 1 11.066 11.062c-.002 6.105-4.952 11.053-11.057 11.053C5.9 23.051.95 18.103.949 11.998Z'
      fill='#282138'
    />
  </svg>
)

export default SvgWrappedBitcoinIcon
